import PopupPersonal from './PopupPersonal';

export default PopupPersonal;
